import { createAdminTheme } from "@workspace/admin-ui";

export const theme = createAdminTheme();
